import { Application, MBS2MRHelper, MBSAccessHelper, Module, Privilege } from '@fides/fides-react-components';
import { User } from '../../../../core/models';

export const addAndEditPageAccessGranted = (accessHelper: MBSAccessHelper, user: User) => {
  const userHasAdminOrEditPermission =
    accessHelper.hasPermissionForModule(Module.USERGROUP, Privilege.ADMIN) ||
    accessHelper.hasPermissionForModule(Module.USERGROUP, Privilege.EDIT);

  const clientLvlImpersonation =
    accessHelper.isImpersonatedAsClient &&
    (accessHelper.isFidesAdministrator(Application.EFTWEB) ||
      accessHelper.isFidesReadOnlyAdministrator(Application.EFTWEB));

  const userLvlImpersonation = user.impersonatedUser && userHasAdminOrEditPermission;

  return (userHasAdminOrEditPermission && !user.impersonated) || clientLvlImpersonation || userLvlImpersonation;
};

export const deleteGranted = (accessHelper: MBSAccessHelper, user: User) => {
  const userHasAdminOrEditPermission =
    accessHelper.hasPermissionForModule(Module.USERGROUP, Privilege.ADMIN) ||
    accessHelper.hasPermissionForModule(Module.USERGROUP, Privilege.EDIT);

  const clientLvlImpersonation =
    accessHelper.isImpersonatedAsClient && accessHelper.isFidesAdministrator(Application.EFTWEB);

  const userLvlImpersonation =
    user.impersonatedUser && accessHelper.isFidesAdministrator(Application.EFTWEB) && userHasAdminOrEditPermission;

  return (userHasAdminOrEditPermission && !user.impersonated) || clientLvlImpersonation || userLvlImpersonation;
};

export const TwoMREnabled = (twoMRHelper: MBS2MRHelper) =>
  twoMRHelper.is2MREnabled && twoMRHelper.is2MREnabledFor(Module.USERGROUP);
